import { SButton, SButtonContainer, SCheckbox, SDialogButton, SIconButton, SInputLabel, STitleContainer, STitleH3 } from '../common/BCommonComponents';
import { RiAddFill } from 'react-icons/ri';
import React, { useEffect, useState } from 'react';
import AuthContext from '../auth/AuthContext';
import { toast } from 'react-toastify';
import { MenuItem, Select, Table, TableBody, TableContainer, TableRow, TextField } from '@material-ui/core';
import { Order, STableCell, STableHead, STableRow } from '../common/ScrivaniaTable';
import Paper from '@material-ui/core/Paper';
import { AslDTO, CooperativaDTO, PuntoServizioDTO, UserRole } from '../common/Dtos';
import { FaSearch, FaTrash } from 'react-icons/all';
import { useHistory } from 'react-router-dom';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FormControl, Grid } from '@material-ui/core/';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ConfirmAlertDialog from '../common/ConfirmDialogComponents';
import AggiungiPuntoServizioDialog from './AggiungiPuntoServizioDialog';
import { AlertDialogContext } from '../common/AlertDialog';


export interface PuntiServizioHeadCell {
	id: keyof PuntoServizioDTO;
	numeric: boolean;
	disablePadding: boolean;
	label: string;
	sortable: boolean;
}

export function PuntiServizio() {
	const auth = React.useContext(AuthContext);
	const alert = React.useContext(AlertDialogContext);
	const history = useHistory();

	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [filteredPuntiServizioList, setFilteredPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [aslList, setAslList] = useState<AslDTO[]>([]);
	const [aslFilter, setAslFilter] = useState<string>('');
	const [servicePointFilter, setServicePointFilter] = useState<string>('');
	const [cooperativaFilter, setCooperativaFilter] = useState<string>('ALL');

	const [order, setOrder] = React.useState<Order>('asc');
	const [orderBy, setOrderBy] = React.useState<keyof PuntoServizioDTO>('name');
	const [selected, setSelected] = React.useState<string[]>([]);
	const [deleteModalVisible, setDeleteModalVisible] = useState(false);
	const [deleteModalMessage, setDeleteModalMessage] = useState('');
	const [addPuntoServizioModalVisible, setAddPuntoServizioModalVisible] = useState(false);
	const [cooperativeList, setCooperativeList] = useState<CooperativaDTO[]>([]);
	// const [alertMessage, setAlertMessage] = useState('');
	// const [openAlert, setOpenAlert] = useState(false);

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	const headCells: PuntiServizioHeadCell[] = [
		{id: 'name', numeric: false, disablePadding: true, label: 'NOME', sortable: true},
		{id: 'cooperativa', numeric: false, disablePadding: true, label: 'COOPERATIVA', sortable: true},
		{id: 'asl', numeric: false, disablePadding: true, label: 'ASL DI COMPETENZA', sortable: true},
		{id: 'indirizzo', numeric: false, disablePadding: true, label: 'INDIRIZZO', sortable: true},
		{id: 'operatori', numeric: false, disablePadding: true, label: 'N. OPERATORI ASSOCIATI', sortable: true},
		{id: 'action', numeric: false, disablePadding: true, label: ' ', sortable: false}
	];

	useEffect(() => {
	}, [orderBy, order, filteredPuntiServizioList]);

	useEffect(() => {
		getAllAsl();
		getAll();
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0) {
			getCooperative();
		}
	}, [auth]);

	const getAllAsl = () => {
		auth.state.axiosInstance?.get('/api/puntoServizio/asl/get_all')
			.then(res => {
				setAslList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero della lista delle Asl!');
				console.log(error);
			})
	}

	const getCooperative = () => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0) {
			auth.state.axiosInstance?.get('/api/cooperativa/listall')
				.then(res => {
					setCooperativeList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero delle Prestazioni!');
					console.log(error);
				})
		}
	}

	const getAll = () => {
		auth.state.axiosInstance?.get('/api/puntoServizio/find_all_punti_servizio',
			{params: {
					cooperativa: cooperativaFilter === 'ALL' ? '' : cooperativaFilter
				}})
			.then(res => {
				let punti_servizio_utili:PuntoServizioDTO[]=[]
				for(let i=0;i<res.data.length;i++){
					let ps:PuntoServizioDTO=res.data[i]
					if(!ps.puntoServizioConfig){
						punti_servizio_utili.push(ps)
					}
				}
				setPuntiServizioList(punti_servizio_utili);
				setFilteredPuntiServizioList(punti_servizio_utili);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
				console.log(error);
			})
	}

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof PuntoServizioDTO) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
		setFilteredPuntiServizioList(filteredPuntiServizio());
	};

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = filteredPuntiServizioList.map((n) => n.id);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
		const selectedIndex = selected.indexOf(id);
		let newSelected: string[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	const closeDeleteModal = () => {
		setDeleteModalVisible(false);
	};

	const closeAddPuntoServizioModal = (puntoServizio?: PuntoServizioDTO)  => {
		if (puntoServizio) {
			auth.state.axiosInstance?.post('/api/puntoServizio/insert', puntoServizio)
				.then(res => {
					history.push("/dettaglio/puntoservizio/" + res.data.id);
				})
				.catch(error => {
					toast.error('🛑 Errore durante il salvataggio del punto di servizio!');
					console.log(error);
				});
		}
		setAddPuntoServizioModalVisible(false);
	};

	const confirmDeleteModal = () => {
		var ids = '';
		selected.filter(id => id !== auth.state.puntoServizioLogged?.id).forEach(id => ids += id + ',');
		ids = ids.substr(0, ids.length - 1);
		auth.state.axiosInstance?.delete('/api/puntoServizio/deleteAllById/' + ids)
			.then(res => {
				getAll();
				setDeleteModalVisible(false);
				setSelected([]);
				toast.success('Punti servizio eliminati con successo!');
			})
			.catch(error => {
				setDeleteModalVisible(false);
				if (406 === error.response.status) {
					alert.setAlertMessage(error.response.data.message);
					alert.setShowAlert(true);
 				} else {
					toast.error('🛑 Errore durante la cancellazione dei Punti di Servizio!');
				}
				console.log(error);
			});

	};

	const handleEliminaSelezionati = () => {
		setDeleteModalMessage('Sei sicuro di voler procedere con la cancellazione?');
		if (selected.findIndex((id) => id === auth.state.puntoServizioLogged?.id) !== -1) {
			setDeleteModalMessage('E\' stato selezionato il Punto di Servizio indicato in fase di autenticazione, questo non verra\' eliminato. \n Sei sicuro di voler procedere con la cancellazione?');
		}
		setDeleteModalVisible(true);
	}

	const handleServicePointChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setServicePointFilter(event.target.value);
	};

	const handleCooperativaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setCooperativaFilter(event.target.value as string);
	};

	const handleAslChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setAslFilter(event.target.value as string);
	};

	const handleDettaglioClick = (punto: PuntoServizioDTO) => {
		history.push("/dettaglio/puntoservizio/" + punto.id);
	};

	const handleSearch = () => {
		setSelected([]);
		setFilteredPuntiServizioList(filteredPuntiServizio());
	}

	const filteredPuntiServizio = (): PuntoServizioDTO[] => {
		let filtered = [...puntiServizioList];

		if (aslFilter && aslFilter !== '' && aslFilter !== 'ALL') {
			filtered = filtered.filter(p => p.asl.toLowerCase().includes(aslFilter.toLowerCase()));
		}

		if (servicePointFilter && servicePointFilter !== '') {
			filtered = filtered.filter(p => p.name.toLowerCase().includes(servicePointFilter.toLowerCase()));
		}

		if (cooperativaFilter && cooperativaFilter !== '' && cooperativaFilter !== 'ALL') {
			filtered = filtered.filter(p => p.cooperativa === cooperativaFilter);
		}

		filtered = filtered.sort(comparator)
		return filtered
	}

	const comparator = (a: PuntoServizioDTO, b: PuntoServizioDTO): number => {
		if (a[orderBy] > b[orderBy]) {
			return order === 'desc' ? -1 : 1;
		}

		if (a[orderBy] < b[orderBy]) {
			return order === 'desc' ? 1 : -1;
		}

		return 0;
	}

	// const handleCloseAlert = () => {
	// 	setOpenAlert(false);
	// 	setAlertMessage('');
	// }

	const isSelected = (name: string) => selected.indexOf(name) !== -1;

	const getAslNome = (aslId: string): string => {
		const asl = aslList.find(a => a.id === aslId);
		if (asl) {
			return asl.name;
		}
		return aslId;
	}

	return (
		<div>
			<STitleContainer>
				<STitleH3>PUNTI DI SERVIZIO DELLA COOPERATIVA</STitleH3>
			</STitleContainer>

			<SButtonContainer>
				<SButton onClick={() => setAddPuntoServizioModalVisible(true)}><RiAddFill className="mr-2"/>Aggiungi</SButton>
				<SButton onClick={handleEliminaSelezionati} variant="rosso"
								 disabled={!selected ||
								 selected.length === 0 ||
				(selected.length === 1 && selected.findIndex((id) => id === auth.state.puntoServizioLogged?.id) !== -1)}><FaTrash className="mr-2"/>Elimina</SButton>
				{/*<SButton variant="verde" disabled={!selected || selected.length === 0}><FaFileDownload className="mr-2"/>Esporta</SButton>*/}
			</SButtonContainer>

			<Grid container spacing={0} className="w-100 mb-3">
				{auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 &&
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="cooperativa">Cooperativa</SInputLabel>
						<Select
							required
							labelId="cooperativa"
							id="cooperativaSelect"
							className={classes.selectEmpty}
							label="Cooperativa"
							value={cooperativaFilter}
							onChange={handleCooperativaChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value="ALL" key="ALL">TUTTE</MenuItem>
							{cooperativeList && cooperativeList.map(op => {
								return (
									<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				}
				<Grid item xs={3} className={auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 ? "px-2" : "pr-2"}>
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="aslSelectLabel">Selezione ASL</SInputLabel>
						<Select
							labelId="aslSelectLabel"
							id="aslSelect"
							value={aslFilter}
							label="Selezione ASL"
							onChange={handleAslChange}
							className={classes.selectEmpty}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							{aslList.map((item) => {
								return (
									<MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>
								);
							})
							}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="px-2">
					<TextField
						className="w-100"
						id="searchServicePoint"
						label="Cerca Punto di Servizio"
						variant="outlined"
						value={servicePointFilter}
						onChange={handleServicePointChange}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
				<Grid item xs={3} className="pl-2 d-flex align-items-center">
					<SIconButton onClick={handleSearch}><FaSearch className="mx-1"/></SIconButton>
				</Grid>
			</Grid>
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
					>
						<PuntiServizioTableHeader
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={filteredPuntiServizioList.length}
							headCells={headCells}
							addCheckbox={true}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{filteredPuntiServizioList &&
							filteredPuntiServizioList
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										<STableRow
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<STableCell padding="checkbox">
												<SCheckbox
													checked={isItemSelected}
													inputProps={{'aria-labelledby': labelId}}
													onClick={(event) => handleClick(event, row.id)}
												/>
											</STableCell>
											<STableCell padding="none">{row.name}</STableCell>
											<STableCell padding="none">{row.cooperativaName}</STableCell>
											<STableCell padding="none">{getAslNome(row.asl)}</STableCell>
											<STableCell padding="none">{row.indirizzo}</STableCell>
											<STableCell padding="none">{row.operatori?.length}</STableCell>
											<STableCell padding="none" className="text-center">
												<SDialogButton className="w-50" onClick={() => handleDettaglioClick(row)}>Dettaglio</SDialogButton>
											</STableCell>
										</STableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
			<ConfirmAlertDialog
				open={deleteModalVisible}
				onCancel={closeDeleteModal}
				onConfirm={confirmDeleteModal}
				message={deleteModalMessage}
			/>
			<AggiungiPuntoServizioDialog
				open={addPuntoServizioModalVisible}
				onClose={closeAddPuntoServizioModal}
				aslList={aslList}
				cooperativeList={cooperativeList}
				/>
			{/*<AlertDialog open={openAlert} onClose={handleCloseAlert} message={alertMessage} />*/}
		</div>
	);
}

interface PuntiServizioTableHeaderProps {
	numSelected: number;
	onRequestSort?: (event: React.MouseEvent<unknown>, property: keyof PuntoServizioDTO) => void;
	onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	order?: Order;
	orderBy?: string;
	rowCount: number;
	headCells: PuntiServizioHeadCell[];
	addCheckbox: boolean;
	bgcolor: string;
	sortable: boolean;
	disableAction: boolean;
}

export function PuntiServizioTableHeader(props: PuntiServizioTableHeaderProps) {
	const {onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, bgcolor, sortable} = props;
	const createSortHandler = (property: keyof PuntoServizioDTO) => (event: React.MouseEvent<unknown>) => {
		if (onRequestSort) {
			onRequestSort(event, property);
		}
	};

	return (
		<TableHead>
			<TableRow>
				{props.addCheckbox &&
				<STableHead padding="checkbox" bgcolor={bgcolor}>
					<SCheckbox
						indeterminate={numSelected > 0 && numSelected < rowCount}
						checked={rowCount > 0 && numSelected === rowCount}
						onChange={onSelectAllClick}
						inputProps={{'aria-label': 'select all'}}
					/>
				</STableHead>
				}

				{props.headCells.map((headCell) => (
					<STableHead
						key={headCell.id}
						align={headCell.numeric ? 'right' : 'left'}
						padding={headCell.disablePadding ? 'none' : 'default'}
						sortDirection={orderBy === headCell.id ? order : false}
						bgcolor={bgcolor}
					>
						{(sortable && order && orderBy) ?
							<TableSortLabel
								active={orderBy === headCell.id}
								direction={orderBy === headCell.id ? order : 'asc'}
								onClick={createSortHandler(headCell.id)}
							>
								{headCell.label}
							</TableSortLabel>
							:
							headCell.label
						}

					</STableHead>
				))}
			</TableRow>
		</TableHead>
	);
}
